import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'automationLocator'
})
export class AutomationLocatorPipe implements PipeTransform {

  transform(value: any, type: LOCATOR_ITEM_TYPES): any {
    value = value && value.split ? value.split(' ').join('_') : '';
    return ['AUTO', type, value].join('_').toUpperCase();
  }

}

export enum LOCATOR_ITEM_TYPES {
  BUTTON = 'BUTTON',
  ICON = 'ICON',
  INPUT = 'INPUT',
  VALUE = 'VALUE',
  ACCORDION = 'ACCORDION'
}
